/**
 * Telling one social sign-in refusal apart from the rest.
 *
 * MohairNotes is clinical only: a patient's own records live in biolockr now.
 * So a brand new social identity arriving with no practice name has nothing to
 * be created for, and the API refuses with its own error code rather than
 * folding into the generic "no account matches that sign-in".
 *
 * That distinction only earns its keep if the client acts on it. This refusal
 * is the one a person can fix in the next click, by registering their practice
 * and giving the clinic name the API is missing. Every other refusal is either
 * a dead end or needs a different action, so routing them all to the same form
 * would send people to fill in a field that cannot help them.
 */
export const SIGNUP_REQUIRES_ORGANIZATION = 'SOCIAL_SIGNUP_REQUIRES_ORGANIZATION';

/**
 * Whether this failure is the one that a practice name would fix.
 *
 * Deliberately total: the catch block that calls this is reached by SDK
 * throws and by requests that failed before any response existed, so anything
 * that is not recognisably that refusal is false rather than an exception.
 */
export function needsOrganization(err: unknown): boolean {
  const code = (err as { response?: { data?: { error_code?: string } } } | null | undefined)?.response?.data?.error_code;
  return code === SIGNUP_REQUIRES_ORGANIZATION;
}
